export default "__VITE_ASSET__BXUer850__"